import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  uploads: []
};

const sparePartUploaderSlice = createSlice({
  name: 'sparePartUploader',
  initialState,
  reducers: {
    addSparePartEntry: (state) => {
      state.uploads.push({
        product_name: "",
        photos: [],
        backlog_id: null,
        log_id: null, // Add this field to track existing entries
        uploadError: ""
      });
    },
    updateSparePartField: (state, action) => {
      const { index, field, value } = action.payload;
      if (state.uploads[index]) {
        state.uploads[index][field] = value;
      }
    },
    deleteSparePartEntry: (state, action) => {
      state.uploads.splice(action.payload, 1);
    },
    clearAllSparePartEntries: (state) => {
      state.uploads = [];
    },
    // Add a new action to set all entries at once (alternative approach)
    setSparePartEntries: (state, action) => {
      state.uploads = action.payload.map(item => ({
        product_name: item.product_name || "",
        photos: item.photos || [],
        backlog_id: item.backlog_id,
        log_id: item.log_id,
        uploadError: ""
      }));
    }
  }
});

export const {
  addSparePartEntry,
  updateSparePartField,
  deleteSparePartEntry,
  clearAllSparePartEntries,
  setSparePartEntries
} = sparePartUploaderSlice.actions;

export default sparePartUploaderSlice.reducer;